import { Accept } from "react-dropzone";

export const MAX_FILE_SIZE = 4.5 * 1024 ** 2;
export const ACCEPTED_FILE_TYPES: Accept = {
  "application/pdf": [".pdf"],
};

export enum ErrorCode {
  InvalidName = "invalid-name",
  MaxFiles = "max-file",
  AlreadyExists = "already-exists",
  FileTooBig = "too-big-file",
}
